import { Box, ButtonBase, Checkbox, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import { useEffect, useMemo, useState } from "react";
import { useGetShippersSelectWithProfilesQuery } from "../../../../newapi/shipper/shipperSlice";
import SHModal from "../../../theme/Modal/SHModal";
import Subheading from "../../../theme/text/Subheading";
import Text from "../../../theme/text/Text";
import { InputDropdown } from "../../../theme/dropdowns/InputDropdown";
import ButtonGroup from "../../../theme/buttons/ButtonGroup";
import Shbutton from "../../../theme/buttons/Shbutton";
import MConfirmation from "../MConfirmation";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import { useFindWorkspacesSelectQuery } from "../../../../newapi/warehouse/workspaceSlice";
import { DropdownBaseV2, ShDropdownQuery } from "../../../theme/dropdowns/Dropdown";
import { CountShQueryDropdown } from "./components/CountShQueryDropdown";

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useDispatch, useSelector } from "react-redux";
import { addAction } from "../../../../newapi/global/actionProgressSlice";
import { usePrintBatchFromShippedOrderIdsMutation } from "../../../../newapi/pickingjob/pickingjobSlice";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../../utils/toasts";
export const MReprintBatchOrders = ({ jobId,open, handleClose,selectedItems }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch();

    const [printBatch, {isLoading}] = usePrintBatchFromShippedOrderIdsMutation();
    const [workspaceError,setWorkspaceError] = useState(null);
    const selectedWorkSpace = useSelector((state) => state.settings.workSpace);

    const [optionMap, setOptionMap] = useState({
        workspace: {
            id:-1,
            name: t("no_selection")
        }
    });
    
    useEffect(() => {
        setOptionMap(prev => ({
            ...prev,
            workspace:selectedWorkSpace,
        }))
    },[selectedWorkSpace])

    const handleSaveChanges = () => {
        if(isLoading) return;
        if(optionMap.workspace.id === -1) {
            setWorkspaceError(t("cart_required"));
            return;

        }

        printBatch({
            id:jobId,
            workspaceId:optionMap.workspace.id,
            orderIds:selectedItems,
         })
        .unwrap()
        .then(res => {
            showToastMessagePostRequest(t, res);
            dispatch(addAction({
                type: "shipping_progress",
                entityType: "pickingjob", 
                entityId: jobId,
            }));
            handleClose();
        })
        .catch(err => {
            showToastMessageRequestError(t("confirm_failed"), t, err);
        });
    };

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }
    return (
        <SHModal
            open={open}
            onClose={() => {handleClose(false)}}
            sx={{
                body: {
                    maxWidth: 800,
                    maxHeight: "80vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems:"center",
                }
            }}
        >
            <Box
                sx={{
                    p: 4,
                    display: "flex",
                    flexDirection: "column",
                    alignItems:"center",
                    maxWidth:500,
                    gap:0.5,
                }}
            >
                <Subheading textAlign="center">{t("print_orders_title")}</Subheading>
                <Text center light>{t("print_orders_subtitle")}</Text>
                
            </Box>

            

            <Box
                sx={{
                    width:1,
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    pb:1,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2
                }}
            >
                
                <Box
                    sx={{
                        p:0.5,
                        
                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                        borderRadius:7,
                        fontWeight:500,
                        color:`${theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"]}`,
                        display:"flex",
                        alignItems:"center",
                        "@media screen and (max-width: 47.9375em)" : {
                            minWidth:"unset",
                            position:"fixed",
                            borderBottomRightRadius:0,
                            borderTopLeftRadius:"28px",
                            bottom:0,
                            top:"unset",
                            left:0,
                            zIndex:1060,
                            width:1,
                            px:2,
                            height:56,
                        }
                        // boxShadow: `0px 0px 19px ${colors.grey[300]}`
                    }}
                >
                    <Box
                        sx={{
                            height:32,
                            display:"flex",
                            alignItems:'center',
                            px:1.5,
                            background:theme.palette.mode === "dark" ? colors.grey[600]: colors.grey[200],
                            color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt['light'],
                            borderRadius:5,
                            fontWeight:"bold",
                            mr:1.5,
                            flexShrink:0,
                            minWidth:40,
                            textAlign:"center",
                        }}
                    >
                        {selectedItems.length}
                        {/* 12321324 */}
                    </Box>
                    
                    {t("order")}
                </Box>

                <ShDropdownQuery
                    onChange={(selected,object) => {
                        setOptionMap(optionMap => ({
                            ...optionMap,
                            workspace: selected !== null ? object : {
                                id:-1,
                                name: t("no_selection")
                            }
                        }))
                    }}
                    valueKey={"id"}
                    dataKey={"data"}
                    shComponent={<CountShQueryDropdown/>}
                    selected={optionMap.workspace.id}
                    // config={{
                    //     type:"stream",
                    //     body: getFilterIds(optionMap),
                    // }}
                    content={useFindWorkspacesSelectQuery}
                    closeOnSelection
                    lazyLoad
                    searchOptions={{
                        enabled:true,
                        placeholder:t("search")
                    }}
                >
                    {({anchorEl,onClick}) => (
                        <ButtonBase
                            onClick={onClick}
                            sx={{
                                height:32,
                                borderRadius:5,
                                background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                border:`1px solid ${workspaceError ? colors.red[400] : theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]}`,
                                display:"flex",
                                alignItems:'center',
                                px:0.5,
                                position:'relative',
                                opacity: 1,
                                "&:before" : {
                                    content:'""',
                                    position:'absolute',
                                    borderRadius:5,
                                    left:0,
                                    top:0,
                                    width:1,
                                    height:1,
                                    background:workspaceError ? colors.red[100] : theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                    // border:`1px solid ${colors.grey[100]}`,
                                    boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                }
                            }}
                        >

                            <Box
                                sx={{
                                    height:24,
                                    lineHeight:"24px",
                                    background:workspaceError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                    borderRadius:3,
                                    border: `1px solid ${workspaceError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                    width:110,
                                    textAlign:"center",
                                    fontSize:14,
                                    fontWeight:"bold",
                                    color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                                }}
                            >
                                {t("workspace")}

                            </Box>
                            <Box
                                sx={{
                                    flex:1,
                                    ml:1.5,
                                    textAlign:"left",
                                }}
                            >
                                <Text bold >
                                    {optionMap.workspace?.name}
                                </Text>
                            </Box>
                            <Box
                                sx={{
                                    display:'flex',
                                    gap:1.5,
                                    alignItems:'center',
                                }}
                            >
                                <Text italic bold variant={workspaceError ? "red" : theme.palette.mode === "dark" ? "blue" :  "primary"}>
                                    {t("required")}
                                </Text>
                                <Box
                                    sx={{
                                        height:24,
                                        width:24,
                                        borderRadius:3,
                                        display:"flex",
                                        alignItems:'center',
                                        justifyContent:"center",
                                        background:workspaceError ? colors.red[100] :  theme.palette.mode === "dark" ? colors.blue[100] :  colors.primary[100],
                                        border: `1px solid ${workspaceError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                        color: workspaceError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                    }}
                                >
                                    <KeyboardArrowDownIcon/>

                                </Box>
                            </Box>

                        </ButtonBase>
                    )}
                </ShDropdownQuery> 


            </Box>

            <Box
                component="footer"
                sx={{
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton
                    isCancel={true}
                    className={"always-visible"}
                    onClick={() => {handleClose(false)}}
                    color="primary"
                    variant="text"
                    startIcon={<ArrowRightAltIcon />}
                >
                    {t("close")}
                </Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton
                        isLoading={isLoading}
                        className={"group-btn"}
                        color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        variant="contained"
                        onClick={handleSaveChanges}
                    >
                        {t("print")}
                    </Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>

    );
};